export default "__VITE_ASSET__CaejpwDQ__"